import script from "./PCConfiguracionPicking.vue?vue&type=script&setup=true&lang=js"
export * from "./PCConfiguracionPicking.vue?vue&type=script&setup=true&lang=js"

import "./PCConfiguracionPicking.vue?vue&type=style&index=0&id=6760f487&lang=scss"

const __exports__ = script;

export default __exports__